import SelectBusinessAccount from "../Meta/SelectBusinessAccount";
import { LINKEDIN } from "../../utils/constants";
import {
  FIELD_REQUIRED,
  LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER,
} from "../../i18n/keysTranslations";

const ModalGalleryAdsPlatformsLinkedInAccountSelect = ({
  control,
  errors,
  t,
  onChangeAccount,
  disableAutoSelect = false,
  disabled = false,
  restrictToCampaignAdvertiserPages = false,
  campaignIntegrationID = "",
  campaignAdvertiserID = "",
}) => {
  return (
    <SelectBusinessAccount
      variant="filled"
      name="platformsData.linkedIn.account"
      label={t(LINKEDIN_ACCOUNT_SHARE_PLACEHOLDER)}
      fullWidth={true}
      control={control}
      platform={LINKEDIN}
      errors={errors}
      onChangeAction={onChangeAccount}
      linkedInForPublishing={true}
      linkedInCompanyPagesOnly={true}
      linkedInRestrictToCampaignAdvertiserPages={
        restrictToCampaignAdvertiserPages
      }
      linkedInCampaignIntegrationID={campaignIntegrationID}
      linkedInCampaignAdvertiserID={campaignAdvertiserID}
      disableAutoSelect={disableAutoSelect}
      disabled={disabled}
      rules={{
        required: {
          value: true,
          message: t(FIELD_REQUIRED),
        },
      }}
    />
  );
};

export default ModalGalleryAdsPlatformsLinkedInAccountSelect;
